import { HTTP } from '@/http-common'

function getApartment (apartmentId) {
  return HTTP.get('/apartments/' + apartmentId)
}

function addApartment (apartmentData) {
  let data = JSON.stringify(apartmentData)

  return HTTP.post('/apartments', data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function updateApartment (apartmentData) {
  let data = JSON.stringify(apartmentData)

  return HTTP.put('/apartments/' + apartmentData.id, data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function deleteApartment (apartmentId) {
  return HTTP.delete('/apartments/' + apartmentId)
}

export { getApartment, addApartment, updateApartment, deleteApartment }



// WEBPACK FOOTER //
// ./src/services/apartment.service.js